import './about-features.scss';
import SafeHtmlRenderer from '../../../providers/SafeHtmlRender';



export function AboutFeatures({item}:any) {

  const {description,image} = item; 

  return (
    <section className="about-features">
        <article className="about-features__item">
          <div className="about-features-content text-left">
   
            <SafeHtmlRenderer html={description} />
          </div>
          {image && (
            <div className="about-features__image">
              <img src={`/api/assets/${image}?key=original`}alt={'Feature image'} />
            </div>
          )}
        </article>
    </section>
  );
}
